module.exports = __webpack_public_path__ + "static/img/ont-logo.58a457d6.svg";